function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "A97408AD-1D56-4F88-B465-690CE0DA8AD8");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "141a_Admin---FSE",
  transform: "translate(-1060.000000, -492.000000)"
}, React.createElement("rect", {
  fill: "#FAFAFA",
  x: 0,
  y: 0,
  width: 1366,
  height: 1024
}), React.createElement("g", {
  id: "Group",
  transform: "translate(32.000000, 484.000000)"
}, React.createElement("g", {
  id: "Search",
  transform: "translate(1016.000000, 0.000000)"
}, React.createElement("rect", {
  id: "Rectangle-Copy-4",
  stroke: "#EAEAEA",
  fill: "#FFFFFF",
  x: 0.5,
  y: 0.5,
  width: 286,
  height: 39,
  rx: 4
}), React.createElement("g", {
  id: "Icon-&-Label",
  transform: "translate(12.000000, 8.000000)",
  fill: "#A4A4A4"
}, React.createElement("g", {
  id: "Icons/ic_search"
}, React.createElement("path", {
  d: "M6.328125,12.703125 C7.20312937,13.5781294 8.26561875,14.015625 9.515625,14.015625 C10.7656313,14.015625 11.8281206,13.5781294 12.703125,12.703125 C13.5781294,11.8281206 14.015625,10.7656312 14.015625,9.515625 C14.015625,8.26561875 13.5781294,7.20312937 12.703125,6.328125 C11.8281206,5.45312063 10.7656313,5.015625 9.515625,5.015625 C8.26561875,5.015625 7.20312937,5.45312063 6.328125,6.328125 C5.45312063,7.20312937 5.015625,8.26561875 5.015625,9.515625 C5.015625,10.7656312 5.45312063,11.8281206 6.328125,12.703125 Z M15.515625,14.015625 L20.484375,18.984375 L18.984375,20.484375 L14.015625,15.515625 L14.015625,14.71875 L13.734375,14.4375 C12.5468691,15.4687552 11.1406331,15.984375 9.515625,15.984375 C7.70311594,15.984375 6.16406883,15.3593813 4.8984375,14.109375 C3.63280617,12.8593687 3,11.3281341 3,9.515625 C3,7.70311594 3.63280617,6.16406883 4.8984375,4.8984375 C6.16406883,3.63280617 7.70311594,3 9.515625,3 C11.3281341,3 12.8593688,3.63280617 14.109375,4.8984375 C15.3593813,6.16406883 15.984375,7.70311594 15.984375,9.515625 C15.984375,10.1718783 15.8281266,10.9140584 15.515625,11.7421875 C15.2031234,12.5703166 14.843752,13.2343725 14.4375,13.734375 L14.71875,14.015625 L15.515625,14.015625 Z",
  id: "s"
})))))));

var SvgSearchIcon = function SvgSearchIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSearchIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search_icon.858aff7b.svg";
export { ForwardRef as ReactComponent };